/*
 * @author: liqian
 * @date: Do not Edit
 * @description:
 */
/*
 * @author: liqian
 * @date: Do not Edit
 * @description: 公共状态模块
 */
export default {
  state: {
    hideLoding: false,//控制遮罩状态
    axiosNum: 0,
    userInfo: '',
    dbsxNumber: 0, //待办事项的数量统计
    crmTodoNumber: 0, // CRM 待办任务的数量统计（Wujie 微前端模式下由 CRM 子应用通过 bus 上报）
    buttons: [], //全局的有权限的按钮数组
    breadcrumb: [], // 当前激活的面包屑
    customer: '',

    currentBreadcrumb: '',//当前激活的面包屑
    menuList: [], // 菜单列表
    currentRoute: '/' //当前路由
  },
  mutations: {
    setCurrentBreadcrumb(state, n) {
      state.currentBreadcrumb = n;
    },
    setButtons(state, n) {
      state.buttons = n;
    },
    setDbsxNumber(state, n) {
      state.dbsxNumber = n;
    },
    setCrmTodoNumber(state, n) {
      state.crmTodoNumber = n;
    },
    userInfo(state, n) {
      state.userInfo = n
    },
    hideLoding(state, n) {
      state.hideLoding = n
    },
    addNum(state) {
      state.axiosNum++
    },
    ruduceNum(state) {
      state.axiosNum--
    },
    customer(state, n) {
      state.customer = n
    },
    SET_BREADCRUMB(state, breadcrumb) {
      state.breadcrumb = breadcrumb;
    },
    SET_MENU_LIST(state, menuList) {
      state.menuList = menuList;
    },
    UPDATE_MENU_STATE(state, currentRoute ) {
      state.currentRoute = currentRoute;
    }
  },
  actions: {},
  getters: {
    breadcrumb: state => state.breadcrumb,
    menuList: state => state.menuList,
    currentRoute: state => state.currentRoute
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/public.js